const decodeBase64Url = (value) => {
  if (!value) return ''

  try {
    const decoded = atob(value)
    const percentEncoded = Array.from(decoded)
      .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
      .join('')

    return decodeURIComponent(percentEncoded)
  } catch (error) {
    return value
  }
}

export default decodeBase64Url
